import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, CardHeader, Modal, ModalBody, ModalHeader } from 'reactstrap';

export default class LowboyRequestNotesButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = { showModal: false };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    render() {
        const { lowboyResource } = this.props;

        if (!lowboyResource || !lowboyResource.jobNotes) {
            return null;
        }

        const { showModal } = this.state;

        return (
            <>
                <CardHeader>
                    <Button
                        type="button"
                        onClick={this.toggleModal}
                        outline
                        color="info"
                        className="w-100"
                        size="sm"
                    >
                        <FontAwesomeIcon icon={faInfoCircle} /> Notes
                    </Button>
                </CardHeader>

                <Modal
                    isOpen={showModal}
                    toggle={this.toggleModal}
                    fade={false}
                >
                    <ModalHeader toggle={this.toggleModal}>
                        Job Notes - {lowboyResource.contractName}
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            The following publication notes were provided.
                        </div>
                        <pre>{lowboyResource.jobNotes}</pre>
                    </ModalBody>
                </Modal>
            </>
        );
    }
}
